export default __webpack_public_path__ + "static/media/jf-submit-br.7f9adeef.svg";